export const IMPERSONATION_URL_HANDLER_COPY = {
  INVALID_LINK_TARGET: 'This link has an invalid email or user id.',
  ACCESS_DENIED: 'Zporti operator access required for this link.',
  START_FAILED: 'Could not start impersonation from link.',
} as const
